import { ApiCaller } from "@virtual-brain-lib/frontend-api";
import { Button } from "@virtual-brain-lib/frontend-design-system/ui";
import { cleanMarkdownForCopy, copyMarkdownToClipboard } from "@virtual-brain-lib/frontend-utils";

import { useChatContext } from "../../core";

export default function MessageActionCopyClipboard({
	messageContent,
}: {
	readonly messageContent: string;
}) {
	const { analyticsEventDomain } = useChatContext();

	const cleanedMessageContent = cleanMarkdownForCopy(messageContent);

	async function copyMessageContentToClipboard() {
		if (cleanedMessageContent) {
			void ApiCaller.track([analyticsEventDomain, "Message", "Copied"]);
			await copyMarkdownToClipboard(
				messageContent,
				"Message successfully copied to clipboard",
			);
		}
	}

	if (!cleanedMessageContent) {
		return null;
	}

	return (
		<Button
			leftIcon="copy"
			variant="solid"
			size="sm"
			color="secondary"
			tooltip={{ children: "Copy to clipboard" }}
			onClick={copyMessageContentToClipboard}
		/>
	);
}
